module.exports = __webpack_public_path__ + "7901fd7af48d0a4f9e6a06581189e573.svg";